import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import {
  getCurrentFY,
  getDaysInFYMonths,
  getFinancialYearMonthsPassed,
} from "../../../../Utilitie";
import MonthWisePWIntNIntGraph from "../GraphView.jsx/MonthWisePWIntNIntGraph";
import MonthWisePWINIGraph from "../GraphView.jsx/MonthWisePWINIGraph";
import AvgMWPWIIntAndNintGraph from "../GraphView.jsx/AvgMWPWIIntAndNintGraph";
const MonthWisePWIIntNIntReport = ({
  PWIdata,
  selectedFy,
  prevPWIdata,
  currPWIdata,
}) => {
  const [int, setInt] = useState("Int");
  const getVariationPercent = (prev, curr) => {
    const p = Number(prev);
    const c = Number(curr);

    if (!p && !c) return "0%";
    if (!p) return "∞%";

    const result = ((c - p) / p) * 100;
    return `${result.toFixed(1)}%`;
  };
  const [loading, setLoading] = useState(false);
  const tableRef = useRef();
  const [selectedRT, setSelectedRT] = useState("Jumbo");

  const monthOrder = [
    // "April",
    // "May",
    // "June",
    // "July",
    // "August",
    // "September",
    // "October",
    // "November",
    // "December",
    // "January",
    // "February",
    // "March",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const sortedPrevPWIData = [...prevPWIdata].sort(
    (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month),
  );
  const sortedCurrPWIData = [...currPWIdata].sort(
    (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month),
  );

  const [allMonths, setAllMonths] = useState([...monthOrder]);
  const mpassed = getFinancialYearMonthsPassed(getCurrentFY(), false);
  const [selectedMonths, setSelectedMonths] = useState([...mpassed]);

  const cmdata = sortedCurrPWIData.filter((o) =>
    selectedMonths.includes(o.month.slice(0, 3)),
  );

  const pmdata = sortedPrevPWIData.filter((o) =>
    selectedMonths.includes(o.month.slice(0, 3)),
  );

  const sectionSet = new Set();
  [...sortedPrevPWIData, ...sortedCurrPWIData].forEach((monthData) => {
    monthData?.data?.forEach((item) => {
      if (item?.section) sectionSet.add(item.section);
    });
  });
  const allSections = Array.from(sectionSet).sort();

  const [selectedSections, setSelectedSections] = useState([]);

  useEffect(() => {
    if (allSections.length > 0) {
      setSelectedSections(allSections);
    }
  }, [JSON.stringify(allSections)]);

  const getSectionData = (monthData, section) => {
    return monthData?.data?.find((d) => d.section === section) || {};
  };
  const daysCount =
    selectedMonths.length === 0
      ? 1
      : getDaysInFYMonths(
          `${selectedFy.slice(0, 5)}${selectedFy.slice(7, 9)}`,
          selectedMonths,
        );
  return (
    <div>
      <div className="papaDiv">
        <div className="d-flex justify-content-between flex-wrap align-items-center gap-2 ">
          <div>
            <label className="fw-bold me-2 mb-0">Select Sections:</label>
            {allSections.map((section) => {
              const isActive = selectedSections.includes(section);
              return (
                <span
                  key={section}
                  className={`badge rounded-pill px-3 py-2 me-2 ${
                    isActive
                      ? "bg-primary text-white"
                      : "bg-secondary text-white"
                  }`}
                  onClick={() =>
                    setSelectedSections((prev) =>
                      prev.includes(section)
                        ? prev.filter((s) => s !== section)
                        : [...prev, section],
                    )
                  }
                  style={{ userSelect: "none", cursor: "pointer" }}
                >
                  {section}
                </span>
              );
            })}
          </div>
          <div>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setSelectedSections([])}
            >
              Deselect All
            </button>
          </div>
        </div>{" "}
        <div className="d-flex justify-content-between flex-wrap gap-2 mt-3">
          <div>
            <label className="fw-bold me-2">Select Months:</label>
            {allMonths.map((month) => {
              const active = selectedMonths.includes(month);
              return (
                <span
                  key={month}
                  className={`badge px-3 py-2 me-2 mb-1 ${
                    active ? "bg-success text-white" : "bg-secondary text-white"
                  }`}
                  onClick={() =>
                    setSelectedMonths((prev) =>
                      prev.includes(month)
                        ? prev.filter((m) => m !== month)
                        : [...prev, month],
                    )
                  }
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  {month}
                </span>
              );
            })}
          </div>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setSelectedMonths([])}
          >
            Deselect All
          </button>
        </div>
      </div>
      <div>
        <div className="d-flex justify-content-between bg-dark text-white p-2">
          <h5>PWI Month Wise Intensive And Non-Intensive Report</h5>
          {loading && <Loading />}

          <div
            className="d-flex
          "
          >
            {" "}
            <select
              className="form-select text-black fw-bolder text-center form-control w-100"
              onChange={(e) => {
                setInt(e.target.value);
              }}
              value={int}
            >
              <option value={"Int"}>Int</option>{" "}
              <option value={"N-Int"}>N-Int</option>
            </select>
            <select
              className="form-select text-black fw-bolder text-center form-control"
              onChange={(e) => setSelectedRT(e.target.value)}
              value={selectedRT}
            >
              <option disabled>Select RT</option>
              <option value="Jumbo">Jumbo</option>
              <option value="Boxn">Boxn</option>
            </select>
          </div>
        </div>

        <div className="row">
          {" "}
          <div className="col-md-12 ">
            <AvgMWPWIIntAndNintGraph
              int={int}
              selectedMonths={selectedMonths}
              selectedSections={selectedSections}
              sortedPrev={sortedPrevPWIData}
              sortedCurr={sortedCurrPWIData}
              selectedRT={selectedRT}
              selectedFy={selectedFy}
            />
          </div>
          <div className="col-md-12 ">
            <MonthWisePWIntNIntGraph
              int={int}
              selectedMonths={selectedMonths}
              selectedSections={selectedSections}
              sortedPrev={sortedPrevPWIData}
              sortedCurr={sortedCurrPWIData}
              selectedRT={selectedRT}
              selectedFy={selectedFy}
            />
          </div>{" "}
          <div className="col-md-12 ">
            <MonthWisePWINIGraph
              int={int}
              selectedMonths={selectedMonths}
              selectedSections={selectedSections}
              sortedPrev={sortedPrevPWIData}
              sortedCurr={sortedCurrPWIData}
              selectedRT={selectedRT}
              selectedFy={selectedFy}
            />
          </div>
        </div>

        <div
          className="table-wrapper table-responsive"
          style={{ maxHeight: "700px" }}
        >
          <table
            ref={tableRef}
            border="1"
            cellPadding="8"
            className="table table-striped table-bordered  "
            style={{ fontSize: "13px" }}
          >
            <thead className="table-dark text-center align-middle">
              <tr>
                <th rowSpan={4}>Month Name</th>
                <th colSpan={selectedSections.length * 2}>
                  Previous Year ({selectedFy.replace(/\d+/g, (y) => +y - 1)})
                </th>{" "}
                <th rowSpan={3}>Total INT</th>
                <th rowSpan={3}>Total N-INT</th>{" "}
                <th colSpan={selectedSections.length * 2}>
                  Current Year ({selectedFy})
                </th>
                <th rowSpan={3}>Total INT</th>
                <th rowSpan={3}>Total N-INT</th>{" "}
                <th colSpan={selectedSections.length * 2}>
                  Variation Percentage
                </th>
              </tr>
              <tr>
                {selectedSections.map((section) => (
                  <th key={`prev-${section}`} colSpan={2}>
                    {section}
                  </th>
                ))}
                {selectedSections.map((section) => (
                  <th key={`curr-${section}`} colSpan={2}>
                    {section}
                  </th>
                ))}
                {selectedSections.map((section) => (
                  <th key={`var-${section}`} colSpan={2}>
                    {section}
                  </th>
                ))}
              </tr>
              <tr>
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`headers-prev-${i}`}>
                    <th>INT</th>
                    <th>N-INT</th>
                  </React.Fragment>
                ))}
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`headers-curr-${i}`}>
                    <th>INT</th>
                    <th>N-INT</th>
                  </React.Fragment>
                ))}
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`headers-var-${i}`}>
                    <th>INT%</th>
                    <th>N-INT%</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>

            <tbody>
              {selectedSections.length > 0 &&
                selectedSections.length > 0 &&
                selectedMonths.map((monthName) => {
                  const prevMonthData = sortedPrevPWIData.find(
                    (m) => m.month.slice(0, 3) === monthName,
                  );
                  const currMonthData = sortedCurrPWIData.find(
                    (m) => m.month.slice(0, 3) === monthName,
                  );

                  return (
                    <tr key={monthName}>
                      <td className="fw-bold text-capitalize">{monthName}</td>
                      {selectedSections.map((section) => {
                        const data = getSectionData(prevMonthData, section);
                        return selectedRT === "Jumbo" ? (
                          <React.Fragment>
                            <td>{data.jumbo_to_intensive ?? "-"}</td>
                            <td>{data.jumbo_to_nonintensive ?? "-"}</td>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <td>{data.boxn_to_intensive ?? "-"}</td>
                            <td>{data.boxn_to_nonintensive ?? "-"}</td>
                          </React.Fragment>
                        );
                      })}
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(prevMonthData, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_intensive`] || 0);
                        }, 0)}
                      </td>
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(prevMonthData, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_nonintensive`] || 0);
                        }, 0)}
                      </td>
                      {selectedSections.map((section) => {
                        const data = getSectionData(currMonthData, section);
                        return selectedRT === "Jumbo" ? (
                          <React.Fragment>
                            <td>{data.jumbo_to_intensive ?? "-"}</td>
                            <td>{data.jumbo_to_nonintensive ?? "-"}</td>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <td>{data.boxn_to_intensive ?? "-"}</td>
                            <td>{data.boxn_to_nonintensive ?? "-"}</td>
                          </React.Fragment>
                        );
                      })}{" "}
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(currMonthData, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_intensive`] || 0);
                        }, 0)}
                      </td>
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(currMonthData, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_nonintensive`] || 0);
                        }, 0)}
                      </td>
                      {selectedSections.map((section) => {
                        const prev = getSectionData(prevMonthData, section);
                        const curr = getSectionData(currMonthData, section);

                        const prevInt =
                          selectedRT === "Jumbo"
                            ? (prev?.jumbo_to_intensive ?? 0)
                            : (prev?.boxn_to_intensive ?? 0);
                        const prevNInt =
                          selectedRT === "Jumbo"
                            ? (prev?.jumbo_to_nonintensive ?? 0)
                            : (prev?.boxn_to_nonintensive ?? 0);

                        const currInt =
                          selectedRT === "Jumbo"
                            ? (curr?.jumbo_to_intensive ?? 0)
                            : (curr?.boxn_to_intensive ?? 0);
                        const currNInt =
                          selectedRT === "Jumbo"
                            ? (curr?.jumbo_to_nonintensive ?? 0)
                            : (curr?.boxn_to_nonintensive ?? 0);

                        return (
                          <>
                            <td>
                              {getVariationPercent(prevInt, currInt)
                                .replace("-100.0%", "-")
                                .replace("∞%", "-")}
                            </td>
                            <td>
                              {getVariationPercent(prevNInt, currNInt)
                                .replace("-100.0%", "-")
                                .replace("∞%", "-")}
                            </td>
                          </>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
            {selectedSections.length > 0 && selectedSections.length > 0 && (
              <tfoot className="fw-bold text-center table-secondary table-dark">
                <tr>
                  <td>Total</td>
                  <>
                    {["prev", "curr"].map((type) => {
                      return (
                        <React.Fragment key={type}>
                          {selectedSections.map((section) => {
                            const dataset =
                              type === "prev"
                                ? sortedPrevPWIData.filter((m) =>
                                    selectedMonths.includes(
                                      m.month.slice(0, 3),
                                    ),
                                  )
                                : sortedCurrPWIData.filter((m) =>
                                    selectedMonths.includes(
                                      m.month.slice(0, 3),
                                    ),
                                  );

                            let toInt = 0;
                            let toNInt = 0;

                            dataset.forEach((m) => {
                              const data = getSectionData(m, section);

                              if (selectedRT === "Jumbo") {
                                toInt += Number(data?.jumbo_to_intensive || 0);
                                toNInt += Number(
                                  data?.jumbo_to_nonintensive || 0,
                                );
                              } else {
                                toInt += Number(data?.boxn_to_intensive || 0);
                                toNInt += Number(
                                  data?.boxn_to_nonintensive || 0,
                                );
                              }
                            });

                            return (
                              <React.Fragment key={`${type}-${section}`}>
                                <td>{toInt}</td>
                                <td>{toNInt}</td>
                              </React.Fragment>
                            );
                          })}

                          <td colSpan={2}>-</td>
                        </React.Fragment>
                      );
                    })}
                  </>

                  {selectedSections.map((section) => {
                    let prevInt = 0,
                      prevNInt = 0,
                      currInt = 0,
                      currNInt = 0;

                    sortedPrevPWIData
                      .filter((m) => selectedMonths.includes(m.month))
                      .forEach((m) => {
                        const data = getSectionData(m, section);
                        if (selectedRT === "Jumbo") {
                          prevInt += Number(data?.jumbo_to_intensive || 0);
                          prevNInt += Number(data?.jumbo_to_nonintensive || 0);
                        } else {
                          prevInt += Number(data?.boxn_to_intensive || 0);
                          prevNInt += Number(data?.boxn_to_nonintensive || 0);
                        }
                      });

                    sortedCurrPWIData
                      .filter((m) => selectedMonths.includes(m.month))
                      .forEach((m) => {
                        const data = getSectionData(m, section);
                        if (selectedRT === "Jumbo") {
                          currInt += Number(data?.jumbo_to_intensive || 0);
                          currNInt += Number(data?.jumbo_to_nonintensive || 0);
                        } else {
                          currInt += Number(data?.boxn_to_intensive || 0);
                          currNInt += Number(data?.boxn_to_nonintensive || 0);
                        }
                      });

                    return (
                      <React.Fragment key={`variation-${section}`}>
                        <td>
                          {getVariationPercent(prevInt, currInt)
                            .replace("-100.0%", "-")
                            .replace("∞%", "-")}
                        </td>
                        <td>
                          {getVariationPercent(prevNInt, currNInt)
                            .replace("-100.0%", "-")
                            .replace("∞%", "-")}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>

                <tr>
                  <td>Avg/M</td>
                  <>
                    {["prev", "curr"].map((type) => {
                      const monthCount =
                        type === "prev" ? pmdata.length : cmdata.length;

                      return (
                        <React.Fragment key={type}>
                          {selectedSections.map((section) => {
                            const dataset =
                              type === "prev"
                                ? sortedPrevPWIData.filter((m) =>
                                    selectedMonths.includes(
                                      m.month.slice(0, 3),
                                    ),
                                  )
                                : sortedCurrPWIData.filter((m) =>
                                    selectedMonths.includes(
                                      m.month.slice(0, 3),
                                    ),
                                  );

                            let toInt = 0;
                            let toNInt = 0;

                            dataset.forEach((m) => {
                              const data = getSectionData(m, section);

                              if (selectedRT === "Jumbo") {
                                toInt += Number(data?.jumbo_to_intensive || 0);
                                toNInt += Number(
                                  data?.jumbo_to_nonintensive || 0,
                                );
                              } else {
                                toInt += Number(data?.boxn_to_intensive || 0);
                                toNInt += Number(
                                  data?.boxn_to_nonintensive || 0,
                                );
                              }
                            });

                            return (
                              <React.Fragment key={`${type}-${section}-avgs`}>
                                <td>{(toInt / monthCount).toFixed(2)}</td>
                                <td>{(toNInt / monthCount).toFixed(2)}</td>
                              </React.Fragment>
                            );
                          })}

                          {/* ⭐ Add this once after finishing all sections for this type */}
                          <td colSpan={2}>-</td>
                        </React.Fragment>
                      );
                    })}
                  </>

                  {selectedSections.map((section) => {
                    let prevInt = 0,
                      prevNInt = 0,
                      currInt = 0,
                      currNInt = 0;

                    sortedPrevPWIData
                      .filter((m) => selectedMonths.includes(m.month))
                      .forEach((m) => {
                        const data = getSectionData(m, section);
                        if (selectedRT === "Jumbo") {
                          prevInt += Number(data?.jumbo_to_intensive || 0);
                          prevNInt += Number(data?.jumbo_to_nonintensive || 0);
                        } else {
                          prevInt += Number(data?.boxn_to_intensive || 0);
                          prevNInt += Number(data?.boxn_to_nonintensive || 0);
                        }
                      });

                    sortedCurrPWIData
                      .filter((m) => selectedMonths.includes(m.month))
                      .forEach((m) => {
                        const data = getSectionData(m, section);
                        if (selectedRT === "Jumbo") {
                          currInt += Number(data?.jumbo_to_intensive || 0);
                          currNInt += Number(data?.jumbo_to_nonintensive || 0);
                        } else {
                          currInt += Number(data?.boxn_to_intensive || 0);
                          currNInt += Number(data?.boxn_to_nonintensive || 0);
                        }
                      });

                    return (
                      <React.Fragment key={`variation-${section}`}>
                        <td>-</td>
                        <td>-</td>
                      </React.Fragment>
                    );
                  })}
                </tr>
                <tr>
                  <td>Avg/D</td>
                  <>
                    {["prev", "curr"].map((type) => {
                      const monthCount =
                        type === "prev" ? pmdata.length : cmdata.length;

                      return (
                        <React.Fragment key={type}>
                          {selectedSections.map((section) => {
                            const dataset =
                              type === "prev"
                                ? sortedPrevPWIData.filter((m) =>
                                    selectedMonths.includes(
                                      m.month.slice(0, 3),
                                    ),
                                  )
                                : sortedCurrPWIData.filter((m) =>
                                    selectedMonths.includes(
                                      m.month.slice(0, 3),
                                    ),
                                  );

                            let toInt = 0;
                            let toNInt = 0;

                            dataset.forEach((m) => {
                              const data = getSectionData(m, section);

                              if (selectedRT === "Jumbo") {
                                toInt += Number(data?.jumbo_to_intensive || 0);
                                toNInt += Number(
                                  data?.jumbo_to_nonintensive || 0,
                                );
                              } else {
                                toInt += Number(data?.boxn_to_intensive || 0);
                                toNInt += Number(
                                  data?.boxn_to_nonintensive || 0,
                                );
                              }
                            });

                            return (
                              <React.Fragment key={`${type}-${section}-avgs`}>
                                <td>{(toInt / daysCount).toFixed(2)}</td>
                                <td>{(toNInt / daysCount).toFixed(2)}</td>
                              </React.Fragment>
                            );
                          })}

                          {/* ⭐ Add this once after finishing all sections for this type */}
                          <td colSpan={2}>-</td>
                        </React.Fragment>
                      );
                    })}
                  </>

                  {selectedSections.map((section) => {
                    let prevInt = 0,
                      prevNInt = 0,
                      currInt = 0,
                      currNInt = 0;

                    sortedPrevPWIData
                      .filter((m) => selectedMonths.includes(m.month))
                      .forEach((m) => {
                        const data = getSectionData(m, section);
                        if (selectedRT === "Jumbo") {
                          prevInt += Number(data?.jumbo_to_intensive || 0);
                          prevNInt += Number(data?.jumbo_to_nonintensive || 0);
                        } else {
                          prevInt += Number(data?.boxn_to_intensive || 0);
                          prevNInt += Number(data?.boxn_to_nonintensive || 0);
                        }
                      });

                    sortedCurrPWIData
                      .filter((m) => selectedMonths.includes(m.month))
                      .forEach((m) => {
                        const data = getSectionData(m, section);
                        if (selectedRT === "Jumbo") {
                          currInt += Number(data?.jumbo_to_intensive || 0);
                          currNInt += Number(data?.jumbo_to_nonintensive || 0);
                        } else {
                          currInt += Number(data?.boxn_to_intensive || 0);
                          currNInt += Number(data?.boxn_to_nonintensive || 0);
                        }
                      });

                    return (
                      <React.Fragment key={`variation-${section}`}>
                        <td>-</td>
                        <td>-</td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              </tfoot>
            )}
          </table>
          {(selectedMonths.length === 0 || selectedSections.length === 0) && (
            <div className="text-danger fw-bold">
              {" "}
              Please Select Months And Section
            </div>
          )}
        </div>
        <DownloadExcel
          tableRef={tableRef}
          fileName={` PWI Month Wise Intensive And Non-Intensive Report - ${selectedFy} ${selectedRT} `}
        />
      </div>
    </div>
  );
};

export default MonthWisePWIIntNIntReport;
